import { AppService } from "app/services/app.service";


export abstract class AbContrato extends AppService {
  abstract getAllContratosIntegrador();
  abstract getAllTipoContrato();
  abstract getAllContratosDTOIntegrador(integradorId);
  abstract migrarContratos(integradorId);
}
